import {
  GET_SURVEY_INVITES,
  FETCH_SURVEY_INVITE,
  ADD_SURVEY_INVITE,
  UPDATE_SURVEY_INVITE,
  DELETE_SURVEY_INVITE,
  CLEAR_SURVEY_INVITES,
  SURVEY_INVITES_PAGE,
  CLEAR_ALL,
  SURVEY_INVITES_PENDING, // Added pending action type
} from "../constants/actions";

const initialState = {
  survey_invites: [],
  pending: false,
  pageNumber: 1,
  created: false,
  updated: false,
};

export default function surveyInvites(state = initialState, action) {
  switch (action.type) {
    case SURVEY_INVITES_PENDING: // Added pending case
      return {
        ...state,
        pending: true,
      };
    case GET_SURVEY_INVITES:
      return {
        ...state,
        survey_invites: action.payload,
        pending: false,
      };
    case SURVEY_INVITES_PAGE:
      return {
        ...state,
        pageNumber: action.payload,
      };
    case FETCH_SURVEY_INVITE:
      return {
        ...state,
        [action.payload.id]: action.payload,
        pending: false,
      };
    case ADD_SURVEY_INVITE:
      return {
        ...state,
        created: action.payload,
        pending: false,
      };
    case UPDATE_SURVEY_INVITE:
      return {
        ...state,
        [action.payload.id]: action.payload,
        pending: false,
      };
    case DELETE_SURVEY_INVITE:
      return {
        ...state,
        updated: Math.random(),
        pending: false,
      };
    case CLEAR_SURVEY_INVITES:
      return {
        ...state,
        ...initialState,
      };
    case CLEAR_ALL:
      return initialState;
    default:
      return state;
  }
}